/* tslint:disable */

declare var Object: any;
export interface OtherPaymentInterface {
  "method": number;
  "orderId": string;
  "reference": string;
  "amount": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "bankTransactionId"?: number;
  "id"?: number;
  order?: any;
  bankTransaction?: any;
}

export class OtherPayment implements OtherPaymentInterface {
  "method": number;
  "orderId": string;
  "reference": string;
  "amount": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "bankTransactionId": number;
  "id": number;
  order: any;
  bankTransaction: any;
  constructor(data?: OtherPaymentInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `OtherPayment`.
   */
  public static getModelName() {
    return "OtherPayment";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of OtherPayment for dynamic purposes.
  **/
  public static factory(data: OtherPaymentInterface): OtherPayment{
    return new OtherPayment(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'OtherPayment',
      plural: 'OtherPayments',
      path: 'OtherPayments',
      idName: 'id',
      properties: {
        "method": {
          name: 'method',
          type: 'number',
          default: 0
        },
        "orderId": {
          name: 'orderId',
          type: 'string'
        },
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "bankTransactionId": {
          name: 'bankTransactionId',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        order: {
          name: 'order',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'orderId',
          keyTo: 'id'
        },
        bankTransaction: {
          name: 'bankTransaction',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'bankTransactionId',
          keyTo: 'id'
        },
      }
    }
  }
}
